import React from 'react'
import { SessionManager } from "../services/SessionManager/SessionManager";
import { Navigate } from 'react-router-dom';


type UserRouteProps = {
	components: Array<any>;
};

// Allow access to only logged In Users 
const UserRoute: React.FC<UserRouteProps> = ({components}) => {

  const isAuthenticated = SessionManager.shared.isLoggedin();

  return isAuthenticated ? 
  (<> {components.map((Component, index) => <Component key={index} />)} </>) 
  : 
  ( <Navigate to={"/login"}/>)
}

export default UserRoute